import { render, staticRenderFns } from "./icon5.vue?vue&type=template&id=ab9fa45a&scoped=true&"
import script from "./icon5.vue?vue&type=script&lang=js&"
export * from "./icon5.vue?vue&type=script&lang=js&"
import style0 from "./icon5.vue?vue&type=style&index=0&id=ab9fa45a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9fa45a",
  null
  
)

export default component.exports